module.exports = __webpack_public_path__ + "static/matbuu-detail1-2ab32bb82bb58303c8741567234aa3a0.png";